import { render } from "./Step1.vue?vue&type=template&id=c24c1cf2"
import script from "./Step1.vue?vue&type=script&lang=js"
export * from "./Step1.vue?vue&type=script&lang=js"

import "./Step1.vue?vue&type=style&index=0&id=c24c1cf2&lang=css"

import exportComponent from "/media/ctis/developer/WorkSpaceFront/eventos-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__